import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=41e6cc0c&scoped=true&lang=pug"
import script from "./proxy.vue?vue&type=script&lang=js"
export * from "./proxy.vue?vue&type=script&lang=js"
import style0 from "./proxy.vue?vue&type=style&index=0&id=41e6cc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e6cc0c",
  null
  
)

export default component.exports